/*
  * Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
  * SPDX-License-Identifier": MIT
  *
  * Licensed under the MIT License. See the LICENSE accompanying this file
  * for the specific language governing permissions and limitations under
  * the License.
  */

import { SET_USER, SET_USER_EMAIL, SET_USER_PHONENUMBER } from "../actionTypes";

const initState = () => ({
	id: '',
	username: '',
	attributes: {},
});

/* eslint import/no-anonymous-default-export: [2, {"allowAnonymousFunction": true}] */
export default function (state = initState(), action) {
	switch (action.type) {
		case SET_USER: {
			const { user } = action.payload;

			if (!user) {
				return initState();
			}

			return {
				id: user.id,
				username: user.username,
				attributes: user.attributes || {},
			};
		}
		case SET_USER_EMAIL: {
			const { email } = action.payload;

			return {
				...state,
				attributes: {
					...state.attributes,
					email,
				},
			};
		}
		case SET_USER_PHONENUMBER: {
			const { phoneNumber } = action.payload;

			return {
				...state,
				attributes: {
					...state.attributes,
					phone_number: phoneNumber,
				},
			};
		}
		default:
			return state;
	}
}
